// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // ⏳ Wait until auth state is determined
  if (loading) {
    return <div className="text-center py-5">⏳ Checking permissions...</div>;
  }

  // 🚫 Not logged in? Go to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Check admin list
  const allowedAdmins = ['aubair245@gmail.com']; // Add more if needed
  const isAdmin = allowedAdmins.includes(currentUser.email);

  // 🚫 Logged in but not admin → send home
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // ✅ All checks passed → show page
  return children;
};

export default AdminRoute;
